module.exports = __webpack_public_path__ + "img/theme11.240c74e9.png";